var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.shop && _vm.client && _vm.card
    ? _c(
        "div",
        {
          staticClass:
            "fidelityCard border-grey7 radius-18 shadow-4 d-flex align-items-stretch flex-wrap no-overflow m-20 flex-center-center",
        },
        [
          _c(
            "div",
            { staticClass: "flex-between-center flex-column p-15 bg-grey3" },
            [
              _c("div", { staticClass: "flex-center-center flex-column" }, [
                _c("div", { staticClass: "shopLogo radius-circle bg-grey2" }, [
                  _c("img", {
                    staticClass: "img-circle",
                    attrs: {
                      width: "100%",
                      height: "100%",
                      src: _vm.UrlService.imagePath(
                        _vm.shop.ShopId,
                        _vm.shop.Logo
                      ),
                      alt: _vm.shop.DefaultName,
                    },
                  }),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "avatarLetters flex-center-center bg-grey3 radius-circle mr-10 border-grey7",
                  },
                  [
                    _c("span", { staticClass: "first" }, [
                      _vm._v(_vm._s(_vm.client.FirstName[0])),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "last" }, [
                      _vm._v(_vm._s(_vm.client.LastName[0])),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "color-grey1 fsize-16 text-black" }, [
                  _vm._v(_vm._s(_vm.shop.DefaultName)),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "color-grey1 fsize-12" }, [
                  _vm._v(_vm._s(_vm.shop.DefaultDescription)),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "flex-between-center mt-20 w-100" }, [
                !_vm.como
                  ? _c(
                      "div",
                      { staticClass: "flex-start-center color-grey2" },
                      [
                        _c("i", {
                          staticClass: "fie-icon_offer fsize-25 mr-5",
                        }),
                        _c("span", { staticClass: "fsize-13" }, [
                          _vm._v("Nº " + _vm._s(_vm.card.cardno)),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm._m(0),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "flex-between-center flex-column p-15" }, [
            _c("div", { staticClass: "flex-1 mx-20 flex-center-center" }, [
              _c(
                "div",
                {
                  staticClass:
                    "qrCode border-grey7 radius-5 p-5 hover-opacity cursor-pointer",
                },
                [
                  !_vm.como
                    ? _c("vue-qr", {
                        attrs: { size: 175, text: _vm.card.cardno },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.como
                    ? _c("img", {
                        attrs: { src: "dist/assets/como.png", width: "175" },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "flex-between-end w-100 pb-5 fsize-13" }, [
              _c("span", { staticClass: "color-grey2" }, [
                _vm._v("Solde actuel"),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "color-grey1 text-bold" }, [
                _vm._v(
                  _vm._s(_vm.card.nbPoints) + " " + _vm._s(_vm.shop.Currency)
                ),
              ]),
            ]),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "iconLink flex-center-center bg-white color-bo-danger hover-opacity cursor-pointer radius-circle",
      },
      [_c("i", { staticClass: "fie-icon_link fsize-13" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }